<template>
	<div class="email-form">
		<header-simple :title="$t('base.profile.change_email')" :subtitle="'Information about the user account.'"></header-simple>
		<!-- <spinner v-if="model.loading"/>
		<form v-if="!model.loading && model.hasData()" @submit.prevent="validateAndSubmit">
			<input-text v-model="model.data.email" name="user_email" :placeholder="$t('labels.profile.new_email')" rules="required|email"/>
			<error-box v-if="form.error" :error="form.error"/>
			<button-submit :loading="form.loading">{{ $t('buttons.actions.update_email') }}</button-submit>
		</form> -->
		<form @submit.prevent="validateAndSubmit">
			<form-panel :error="form.error" :loading="model.loading">
				<input-text v-model="model.data.email" name="user_email" :placeholder="$t('labels.profile.new_email')" rules="required|email"/>
				<template v-slot:footer>
					<button-submit :loading="form.loading">{{ $t('buttons.actions.update_email') }}</button-submit>
				</template>
			</form-panel>
		</form>
	</div>
</template>

<script>
import HeaderSimple from '@/modules/ui/HeaderSimple'
import FormPanel from '@/modules/ui/FormPanel'
import ApiObject from '@/classes/api/ApiObject'
import FormObject from '@/classes/api/FormObject'
export default {
	props: [
		'user_uid'
	],
	components: {
		HeaderSimple,
		FormPanel
	},
	data () {
		return {
			model: new ApiObject(),
			form: new FormObject()
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.updateEmail()
				})
		},
		getUser () {
			this.model.loading = true
			this.$api.users.getByUid(this, this.user_uid)
				.then(response => {
					this.$log.info('account information', 'users.getByUid OK', response)()
					this.model.data = response.body
				})
				.catch(error => {
					this.$log.error('account information', 'users.getByUid ERROR', error)()
					this.model.error = error
				})
				.finally(() => {
					this.model.loading = false
				})
		},
		updateEmail () {
			this.form.loading = true
			this.form.error = null
			this.$api.users.email.edit(this, this.user_uid, this.model.data)
				.then(response => {
					// this.$log.info('user profile', 'users.email.edit OK', response)()
					this.$root.$emit('add-floating-box', { type: 'success', title: 'Success', message: 'Email updated.' })
				})
				.catch(error => {
					// this.$log.error('user profile', 'users.email.edit ERROR', error)()
					this.form.error = error
					this.$root.$emit('add-floating-box', { type: 'error', title: 'Error', message: 'Issue try to update email. Try again please.' })
				})
				.finally(() => {
					this.form.loading = false
				})
		}
	},
	mounted () {
		this.getUser()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/accountinformation/EmailForm.vue